import Item from './item';
import { GET_FEATURED_POST } from '@core/ui/graphql/Packages.query';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'next-i18next';
import OwlCarousel from './carousel';
import { FeaturedTopWrapper } from '../../featured.style';

const arrowNext = `
  <svg width="18px" height="14px" viewBox="0 0 16 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 61 (89581) - https://sketch.com -->
      <title>arrow</title>
      <desc>Created with Sketch.</desc>
      <g id="Site-web" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Yatoo-UI-02.1-Annonce-detail" transform="translate(-765.000000, -371.000000)" fill="#000000">
              <g id="content" transform="translate(0.000000, 80.000000)">
                  <g id="img" transform="translate(65.000000, 77.000000)">
                      <g id="1">
                          <g id="arrows" transform="translate(20.000000, 192.000000)">
                              <g id="right" transform="translate(661.000000, 0.000000)">
                                  <g id="arrow" transform="translate(19.000000, 22.000000)">
                                      <path d="M15.71,4.29411452 L11.71,0.29411452 C11.4563414,0.0404559387 11.086626,-0.0586090188 10.740122,0.0342364597 C10.3936179,0.127081938 10.1229674,0.397732415 10.0301219,0.744236472 C9.93727646,1.09074053 10.0363414,1.46045595 10.29,1.71411452 L12.59,4.00411452 L1,4.00411452 C0.44771525,4.00411452 5.0004445e-13,4.45182977 5.0004445e-13,5.00411452 C5.0004445e-13,5.55639927 0.44771525,6.00411452 1,6.00411452 L12.59,6.00411452 L10.29,8.29411452 C10.1006873,8.48188112 9.99420168,8.73747698 9.99420168,9.00411452 C9.99420168,9.27075206 10.1006873,9.52634792 10.29,9.71411452 C10.4777666,9.90342717 10.7333625,10.0099128 11,10.0099128 C11.2666375,10.0099128 11.5222334,9.90342717 11.71,9.71411452 L15.71,5.71411452 C15.8010406,5.61901081 15.8724056,5.50686584 15.92,5.38411452 C16.020018,5.14065316 16.020018,4.86757588 15.92,4.62411452 C15.8724056,4.5013632 15.8010406,4.38921823 15.71,4.29411452 Z" id="Path"></path>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
`;

const arrowPrev = `
  <svg width="18px" height="14px" viewBox="0 0 16 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 61 (89581) - https://sketch.com -->
    <title>arrow</title>
    <desc>Created with Sketch.</desc>
    <g id="Site-web" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Yatoo-UI-02.1-Annonce-detail" transform="translate(-105.000000, -371.000000)" fill="#000000">
            <g id="content" transform="translate(0.000000, 80.000000)">
                <g id="img" transform="translate(65.000000, 77.000000)">
                    <g id="1">
                        <g id="arrows" transform="translate(20.000000, 192.000000)">
                            <g id="left" transform="translate(27.500000, 27.500000) scale(-1, 1) translate(-27.500000, -27.500000) ">
                                <g id="arrow" transform="translate(19.000000, 22.000000)">
                                    <path d="M15.71,4.29411452 L11.71,0.29411452 C11.4563414,0.0404559387 11.086626,-0.0586090188 10.740122,0.0342364597 C10.3936179,0.127081938 10.1229674,0.397732415 10.0301219,0.744236472 C9.93727646,1.09074053 10.0363414,1.46045595 10.29,1.71411452 L12.59,4.00411452 L1,4.00411452 C0.44771525,4.00411452 5.0004445e-13,4.45182977 5.0004445e-13,5.00411452 C5.0004445e-13,5.55639927 0.44771525,6.00411452 1,6.00411452 L12.59,6.00411452 L10.29,8.29411452 C10.1006873,8.48188112 9.99420168,8.73747698 9.99420168,9.00411452 C9.99420168,9.27075206 10.1006873,9.52634792 10.29,9.71411452 C10.4777666,9.90342717 10.7333625,10.0099128 11,10.0099128 C11.2666375,10.0099128 11.5222334,9.90342717 11.71,9.71411452 L15.71,5.71411452 C15.8010406,5.61901081 15.8724056,5.50686584 15.92,5.38411452 C16.020018,5.14065316 16.020018,4.86757588 15.92,4.62411452 C15.8724056,4.5013632 15.8010406,4.38921823 15.71,4.29411452 Z" id="Path"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
  </svg>
`;

const List = ({ category, text, ...props }) => {
  const { t } = useTranslation();

  const { data, error } = useQuery(GET_FEATURED_POST, {
    variables: {
      category: category !== null ? t('category.slug.' + category) : '',
      text,
      limit: 3,
    },
    ssr: false,
  });

  if (error) {
    return null;
  }

  const { featured } = data || {};
  const { data: featuredData = [] } = featured || {};

  return (
    <FeaturedTopWrapper
      className={featuredData.length === 0 ? 'empty' : 'show'}
    >
      {featuredData.length > 0 && (
        <OwlCarousel
          className={
            featuredData.length === 0
              ? 'owl-theme hide-carousel'
              : 'owl-theme show-carousel'
          }
          center={true}
          autoplay={false}
          loop={true}
          nav={true}
          dots={true}
          responsive={{
            0: {
              items: 1,
            },
            580: {
              items: 2,
            },
            1200: {
              items: 3,
            },
          }}
          navText={[arrowPrev, arrowNext]}
        >
          {featuredData.map(item => (
            <Item data={item} key={item.sid} />
          ))}
        </OwlCarousel>
      )}
    </FeaturedTopWrapper>
  );
};

export default List;
